import {
    TOGGLE_UPLOAD_OPTIONS,
    TOGGLE_LINK_SLIDER,
    TOGGLE_COPY_SLIDER,
    TOGGLE_SEARCH_IMAGE
} from '../actions/types';

const initialState = {
    type: '',//image, video,
    sliderType: '',//upload, link,
    data: {}
};

export default function(state=initialState, action) {
    switch(action.type) {
        case TOGGLE_UPLOAD_OPTIONS:
            if(!action.payload.show) {
                return {
                    ...state,
                    sliderType: '',
                    ...action.payload,
                    type: ''
                };
            }
            return {
                ...state,
                ...action.payload,
                sliderType: 'upload'
            };
        case TOGGLE_LINK_SLIDER:
            if(!action.payload.show) {
                return {
                    ...state,
                    sliderType: '',
                    type: ''
                };
            }
            return {
                ...state,
                ...action.payload,
                sliderType: 'link'
            };
        case TOGGLE_COPY_SLIDER:
            if(!action.payload.show) {
                return {
                    ...state,
                    sliderType: '',
                    ...action.payload,
                    type: ''
                };
            }
            return {
                ...state,
                ...action.payload,
                sliderType: 'copy'
            };
        case TOGGLE_SEARCH_IMAGE:
            if(!action.payload.show) {
                return {
                    ...state,
                    sliderType: '',
                    ...action.payload,
                    type: ''
                };
            }
            return {
                ...state,
                ...action.payload,
                sliderType: 'searchLibrary'
            }
        default:
            return state;
    }
}